export const UPDATE_WEATHER = 'UPDATE_WEATHER';
export const UPDATE_FORECAST = 'UPDATE_FORECAST';
export const UPDATE_DARKMODE = 'UPDATE_DARKMODE';
export const UPDATE_FORMAT = 'UPDATE_FORMAT';
